module.exports = __webpack_public_path__ + "img/vignette_sol_reduit.7c777bda.png";